module.exports = __webpack_public_path__ + "static/img/qrcode5.fa675e2b.png";